import { makeErrorWithCode } from '@neo-one/utils';
export const NothingToIssueError = makeErrorWithCode('NOTHING_TO_ISSUE', () => 'Nothing to issue.');

//# sourceMappingURL=errors.js.map
